
import { Vue, Component, Prop, Emit } from 'vue-property-decorator';

import { ButtonPrimary } from '@warrenbrasil/nebraska-web';

import {
  TradeNegotiationAvailable,
  ETradeNegotiationButtonState
} from '@/modules/common/services/graphql/server/server.sdk';

import { OrderType } from '../../types';

@Component({
  components: {
    ButtonPrimary
  }
})
export default class OrderButton extends Vue {
  @Prop({ type: Object, required: true })
  readonly negotiationAvailable!: TradeNegotiationAvailable;

  @Prop({ type: Number, required: true })
  readonly orderType!: OrderType;

  @Prop({ type: String, required: true })
  readonly label!: string;

  @Emit('order-button-action')
  public defaultClick() {}

  get buttonType() {
    return this.orderType === OrderType.Buy
      ? this.negotiationAvailable.buy!
      : this.negotiationAvailable.sell!;
  }

  get isDisabled() {
    return this.buttonType.state === ETradeNegotiationButtonState.Disabled;
  }

  get buttonLabel() {
    return this.buttonType.button ? this.buttonType.button : this.label;
  }
}
